export default __webpack_public_path__ + "static/media/1128040325514330.93cfcc70.jpg";